import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-hotspot-list',
  templateUrl: './hotspot-list.component.html',
  styleUrls: ['./hotspot-list.component.scss']
})
export class HotspotListComponent implements OnInit {
  @Input() hotspotListData;
  @Input() spaceData;
  @Input() mediaData;
  @Input() selectedMedia;
  @Output() changeHotspotEmit = new EventEmitter();
  @Output() closeMenuEmit = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  changeHotspot(hotspot) {
    // if (this.selectedMedia.uuid !== hotspot.media_link.uuid) {
    this.changeHotspotEmit.emit(hotspot);
    // }
  }

  closeMenu() {
    this.closeMenuEmit.emit(true);
  }

}
